import PropTypes from 'prop-types';

export default PropTypes.shape({
  title: PropTypes.string,
  category: PropTypes.string,
  set: PropTypes.func.isRequired,
  subscribe: PropTypes.func.isRequired,
});
